import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Tab from 'components/shared/Tab';
import { ifProp } from 'styled-tools';

const propTypes = {
  center: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  right: PropTypes.bool,
  application: PropTypes.bool,
};

const defaultProps = {
  center: false,
  className: null,
  right: false,
  application: false,
};

function Tabs({ center, children, className, right, application }) {
  return (
    <Container application={application} center={center} right={right} className={className}>
      {children}
    </Container>
  );
}

const Container = styled.ul`
  display: flex;
  justify-content: ${({ center, right }) => {
    if (center) return 'center';
    if (right) return 'flex-end';
    return 'flex-start';
  }};
  margin: 0;
  padding: 0;
  list-style-type: none;
  border-bottom: ${ifProp('application', '0.0625rem solid var(--color-primary)', '0.0625rem solid #EBEBEB')};
  z-index: 3;
  position: relative;

  ${Tab} {
    margin-left: 1.875rem;
    &:first-child {
      margin-left: 0;
    }
  }
  @media (max-width: 768px) {
    flex-wrap: wrap;
    justify-content: flex-start;
    overflow-x: auto;
    border-bottom-width: 1px;
    ${Tab} {
      margin-left: 0.75rem;
      margin-bottom: 0.5rem;
      flex: 0 0 auto;
      &:first-child {
        margin-left: 0.75rem;
      }
    }
  }
`;

Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;

export default Tabs;
